import React, { useRef, useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

interface Props {
  primary: string;
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline'
    | 'inherit'
    | undefined;
  fontSize?: number;
  color?: string;
}

const OverflowTooltip = ({ primary, variant, fontSize, color }: Props) => {
  const textElementRef = useRef<HTMLInputElement | null>(null);

  const compareSize = () => {
    if (!textElementRef.current) return;

    const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
  }, []);

  useEffect(
    () => () => {
      window.removeEventListener('resize', compareSize);
    },
    [],
  );

  const [hoverStatus, setHover] = useState(false);

  return (
    <Tooltip title={primary} disableHoverListener={!hoverStatus} placement={'right'}>
      <Typography
        ref={textElementRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        color={color}
        sx={{ fontSize: fontSize }}
        variant={variant}
      >
        {primary}
      </Typography>
    </Tooltip>
  );
};

export default OverflowTooltip;
